import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'getting-started',
});

export const academyContributorRouteRef = createSubRouteRef({
  id: 'getting-started:academy-contributor',
  parent: rootRouteRef,
  path: '/backstage-developer/academy-contributor',
});

export const techDocsContributorRouteRef = createSubRouteRef({
  id: 'getting-started:techdocs-contributor',
  parent: rootRouteRef,
  path: '/backstage-developer/docs-contributor',
});

export const backstageDeveloperRouteRef = createSubRouteRef({
  id: 'getting-started:backstage-developer',
  parent: rootRouteRef,
  path: '/backstage-developer',
});

export const templatesContributorRouteRef = createSubRouteRef({
  id: 'getting-started:templates-contributor',
  parent: rootRouteRef,
  path: '/backstage-developer/templates-contributor',
});

export const uxHandbookRouteRef = createSubRouteRef({
  id: 'getting-started:ux-handbook',
  parent: rootRouteRef,
  path: '/backstage-developer/ux-handbook',
});
